import { baseApi } from './baseApi';
import { IRootState } from '../state/rootReducer';

const inquiryApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
        sendInquiry: build.mutation<{}, { message: string }>({
            queryFn: async ({ message }, api, _extraOptions, baseQuery) => {
                const state = api.getState() as IRootState;
                const user = state.user.user;
                const result = await baseQuery({
                    url: '/system/inquiries/',
                    method: 'POST',
                    body: { message, email: user?.email ?? 'anonymous' },
                });
                return result.data ? { data: result.data } : { error: result.error };
            },
        }),
    }),
});

export const { useSendInquiryMutation } = inquiryApi;
